<template>
    <ListModule
        :label="$t('components.smart.featuredCompanies.label')"
        :data="featuredPostings"
        :to="companyURL()"
        :isLoading="loading"
    />
</template>

<script>
import CompanyService from '~/services/CompanyService';
import SchoolService from '~/services/SchoolService';

export default {
    name: 'FeaturedCompanies',
    data() {
        return {
            doublePromotion: {},
            singlePromotion: {
                1984: true, // AB InBev Europe
                3828: true, // AXA Investment Managers
                203: true, // Schneider Electric
                2553: true, // BBVA
                3485: true, // Amazon UK
            },
            featuredPostings: [],
            loading: false,
        };
    },
    methods: {
        companyURL: function() {
            return this.$URLS.findcompanies;
        },
        fetchFeaturedCompanies() {
            this.loading = true;
            CompanyService.getCompanies({
                page: 1,
                limit: 10,
                minified: false,
                subdomain: SchoolService.getCurrentSchoolDomain(),
                companyIds: Object.keys(this.singlePromotion),
            })
                .then(response => {
                    this.featuredPostings = response.data
                        .sort(() => 0.5 - Math.random())
                        .slice(0, 5)
                        .map(value => ({
                            id: value.id,
                            header: value.title,
                            subheader: ''.concat(
                                value.country || '',
                                value.country && value.location ? ', ' : '',
                                value.location || ''
                            ),
                            image: value.logo,
                        }));
                })
                .finally(() => (this.loading = false));
        },
    },
    mounted() {
        this.fetchFeaturedCompanies();
    },
};
</script>

<style scoped></style>
